import envManager from './EnvManager';

import './EnvMode.scss';

const EnvMode: React.FC = () => {
    return (
        <div className="env_mode_container">
            {envManager.developmentMode !== "Prod" && <div>{envManager.developmentMode}</div>}
        </div>
    )
}

export default EnvMode;